<template>
	<Popup
		v-model="selfDisplay"
		title="重置训练难度"
		:confirmBtnDisplay="reset_need"
		confirmBtnText="重置"
		@confirmClick="handleConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<h3 style="font-size: 18px;line-height: 30px;">{{ reset_need ? "您确定截止频率任务要重置吗？" : "该任务已重置！" }}</h3>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			uid: {
				type: String,
				default: ''
			}
		},
		mounted () {
			this.reset_id = '';
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				selfDisplay: false,
				loading: false,
				reset_need: true
			}
		},
		methods: {
			/********************** @Events ************************/
			// 点击确定
			handleConfirmClick() {
				this.resetUserTask();
			},
			
			/********************** @Function ************************/
			// 查询患者任务
			getUserTask() {
				const that = this;
				that.loading = true;
				let requestData = {
					missionId: 1,
					userPatientId: that.uid
				};
				Api.getUserTask(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.reset_need = res.data.data[0].missionIndex != -3
							? true
							: false;
						that.reset_id = res.data.data[0].missionPatientRelativeId;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 重置患者任务
			resetUserTask() {
				const that = this;
				that.loading = true;
				let requestData = {
					missionIndex: -3,
					missionPatientRelativeId: that.reset_id
				};
				Api.resetUserTask(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.selfDisplay = false;
						that.$message.success(res.data.message);
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display (newValue) {
				this.selfDisplay = newValue;
			},
			selfDisplay (newValue) {
				this.$emit('changeDisplay', newValue);
				if (newValue) {
					this.getUserTask();
				} else {
					this.loading = false;
					this.reset_need = true;
				}
			}
		}
	}
</script>

<style>
</style>
